var render = function (_h,_vm) {var _c=_vm._c;return _c('p',_vm._b({staticClass:"col-start-1 col-span-6 lg:col-start-2 lg:col-span-4 text-3-mob lg:text-4-desk",class:_vm.data.staticClass || ''},'p',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }